/* src/app/modules/shared/page-header/page-header.component.scss */
/*# sourceMappingURL=page-header.component-WIXOL555.css.map */
